import React from 'react';
import styled from 'styled-components/macro';
import { FormHelperText as MuiFormHelperText } from '@material-ui/core';

// filter hasError prop
const FormHelperText = ({ hasError, ...props }) => (
  <MuiFormHelperText {...props} />
);

export default styled(FormHelperText)`
  && {
    font-size: 0.875rem;
    margin: 8px 0 -16px;
  }

  ${({ hasError, theme }) =>
    hasError && {
      color: theme.palette.error.main
    }}
`;
